import React, { useCallback, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import useBillAddressState from '../useBillAddress';

const useSelectCountry = () => {
  const navigate = useNavigate();
  const { data, modifyData, setModifyData } = useBillAddressState();

  const onSelect = useCallback(
    (countryCode: any) => {
      setModifyData({
        countryCode,
        postal: '',
        county: '',
        city: '',
        state: '',
        address: '',
      });
      navigate(-1);
    },
    [navigate, setModifyData],
  );

  // useEffect(() => {
  //   // 这个页面刷新回到上一页
  //   // 辅助上一页的表单
  //   if (!modifyData.fromAddressPage) {
  //     navigate(-1);
  //   }
  // }, [modifyData.fromAddressPage, navigate]);

  const finalData = useMemo(
    () => ({ countryCode: 'USA', ...data, ...modifyData }),
    [data, modifyData],
  );

  return {
    countryCode: finalData.countryCode,
    onSelect,
  };
};

export default useSelectCountry;
